<script>
import { computed, ref, watch } from 'vue'

export default {
  name: 'TextField',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: null,
    },
    disableNewLine: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const textareaEl = ref()

    const currentValue = ref(props.modelValue)

    const maxLengthLetterCount = computed(() => {
      if (currentValue.value) {
        return currentValue.value.length
      }
      return 0
    })

    const changeValue = (value) => {
      if (props.disableNewLine) {
        value = value.replace(/(\r\n|\n|\r)/gm, '')
        textareaEl.value.value = value
      }

      currentValue.value = value

      emit('update:modelValue', value)
    }

    return {
      textareaEl,
      currentValue,
      maxLengthLetterCount,
      changeValue,
    }
  },
}
</script>

<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="block font-bold uppercase mb-1">
      {{ label }}
      <span v-if="required">*</span>
    </label>

    <textarea
      :id="id"
      :type="type"
      :placeholder="placeholder"
      v-bind="$attrs"
      class="form-control"
      :value="currentValue"
      :class="height || ''"
      @input="changeValue($event.target.value)"
      :maxlength="maxLength"
      ref="textareaEl"
    ></textarea>

    <div class="text-6 italic text-right mt-2" v-if="maxLength">
      {{
        __('form.max_text_length', {
          count: `${maxLengthLetterCount}/${maxLength}`,
        })
      }}
    </div>
  </div>
</template>
